import Fetch from '../../apiConfig/apiConfig';
import { AxiosPromise } from 'axios';
import { ICreateOrderResponse } from './ICreateOrderResponse';
import { ICreateOrderParams } from './ICreateOrderParams';

export const createOrder = (params: ICreateOrderParams) : AxiosPromise<ICreateOrderResponse> => {
  return Fetch().then(axios => axios.post('orders/create', params));
};
